

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import '../Invoice/Invoice.css';
import axios from 'axios';
import jsPDF from 'jspdf';


import { notoSansBase64 } from './notosans';
import { verdanaFont } from './verdant';
import { verdanaboldFont } from './verdanbold';

const InvoiceForm = () => {
  const dateInputStyle = {
    cursor: 'pointer',
    caretColor: 'transparent',
    userSelect: 'none'
  };
  const [invoiceData, setInvoiceData] = useState({
    invoiceNumber: '',
    date: '',
    terms: '',
    dueDate: '',
    billToName: '',
    billtocompanyname: '',
    billToAddress: '',
    billToemail: '',
    billTophone: '',
    billTogstin: '',
    shipToName: '',
    shipTocompanyname: '',
    shipToAddress: '',
    shipToemail: '',
    shipTophone: '',
    shipTogstin: '',

    subTotal: '',
    subTotal: '',
    cgst: '',
    sgst: '',
    total: '',
    balanceDue: '',
    totalDiscount: '0.00',
    totalInWords: '',
    year: '24-25',
    thankYouMessage: 'Thank you for the valuable business! We will always be at your desk to support you.',
    termsAndConditions: 'Full payment is due upon receipt of this invoice. Late payments may incur additional charges or interest As per the applicable laws.',
    bankDetails: `Name: Excerpt Technologies Private Limited
Account Number: 10063739760
Name of Bank: IDFC First Bank 
IFSC Code: IDFB0080151
PAN No : AAGCE2327K`,
  });

  const [cgstRate, setCgstRate] = useState('');
  const [sgstRate, setSgstRate] = useState('');
  const [lastInvoiceNumber, setLastInvoiceNumber] = useState(0);
  const [previewing, setPreviewing] = useState(null);
  const [discounts, setDiscounts] = useState([
    { label: '', amount: '' }
  ]);
  const [saving, setSaving] = useState(false);
  const [parts, setParts] = useState([
    { title: 'Part A', items: [{ description: '', amount: '' }] },
  ]);

  const navigate = useNavigate();
  const convertNumberToWords = (amount) => {
    const words = [
      '', 'One', 'Two', 'Three', 'Four', 'Five', 'Six',
      'Seven', 'Eight', 'Nine', 'Ten', 'Eleven', 'Twelve',
      'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen',
      'Seventeen', 'Eighteen', 'Nineteen'
    ];
    const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
    // Update the useEffect that calculates totals to also set balance due

    const convert = (num) => {
      if (num < 20) return words[num];
      if (num < 100) return tens[Math.floor(num / 10)] + (num % 10 ? ' ' + words[num % 10] : '');
      if (num < 1000) return words[Math.floor(num / 100)] + ' Hundred' + (num % 100 ? ' and ' + convert(num % 100) : '');
      if (num < 100000) return convert(Math.floor(num / 1000)) + ' Thousand' + (num % 1000 ? ' ' + convert(num % 1000) : '');
      if (num < 10000000) return convert(Math.floor(num / 100000)) + ' Lakh' + (num % 100000 ? ' ' + convert(num % 100000) : '');
      return convert(Math.floor(num / 10000000)) + ' Crore' + (num % 10000000 ? ' ' + convert(num % 10000000) : '');
    };

    const [whole, decimal] = Number(amount).toFixed(2).split('.');
    const inWords = convert(parseInt(whole)) + ' Rupees';
    const paisa = parseInt(decimal) ? ' and ' + convert(parseInt(decimal)) + ' Paise' : '';
    return inWords + paisa + ' only';
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-GB');
  };

  const formatCurrency = (amount) => {
    return `₹ ${parseFloat(amount).toFixed(2)}`;
  };
  ; const [sameAsBillTo, setSameAsBillTo] = useState(false);

  // 2. Add these validation functions after your existing helper functions
  const validateEmail = (email) => {
    if (!email) return true; // Optional field

    // Regex: local part does NOT contain '@' or '.', then '@', then a domain with at least one dot.
    const emailRegex = /^[^@.\s]+@[^@\s]+\.[^@\s]+$/;

    return emailRegex.test(email);
  };

  const validatePhone = (phone) => {
    if (!phone) return true; // Optional field
    // Remove spaces and check format: +91 followed by 10 digits starting with 6,7,8,9
    const cleanPhone = phone.replace(/\s+/g, '');
    const phoneRegex = /^\+91[6-9]\d{9}$/;
    return phoneRegex.test(cleanPhone);
  };

  const validateGST = (gst) => {
    if (!gst) return true; // Optional field
    // GST format: 15 characters alphanumeric
    const gstRegex = /^[A-Z0-9]{15}$/;
    return gstRegex.test(gst.toUpperCase());
  };

  // 3. Add this handler for the checkbox
  const handleSameAsBillTo = (e) => {
    const isChecked = e.target.checked;
    setSameAsBillTo(isChecked);

    if (isChecked) {
      setInvoiceData(prev => ({
        ...prev,
        shipToName: prev.billToName,
        shipTocompanyname: prev.billtocompanyname,
        shipToAddress: prev.billToAddress,
        shipToemail: prev.billToemail,
        shipTophone: prev.billTophone,
        shipTogstin: prev.billTogstin,
      }));
    }
  };

  // 4. Update your handleInvoiceDataChange function to include validation
  // 4. Update your handleInvoiceDataChange function to include validation
  const handleInvoiceDataChange = (e) => {
    const { name, value } = e.target;

    // Phone validation
    if (name === 'billTophone' || name === 'shipTophone') {
      // Only allow +91 format with digits
      if (value && !value.startsWith('+91')) {
        if (value.match(/^[6-9]/)) {
          const newValue = '+91' + value;
          setInvoiceData(prev => ({ ...prev, [name]: newValue }));

          // If updating billTo field and checkbox is checked, update shipTo field too
          if (sameAsBillTo && name.startsWith('billTo')) {
            const shipToField = name.replace('billTo', 'shipTo');
            setInvoiceData(prev => ({ ...prev, [shipToField]: newValue }));
          }
          return;
        }
        return; // Don't update if invalid format
      }
      // Allow only digits after +91
      if (value.length > 3) {
        const phoneDigits = value.slice(3);
        if (!/^\d*$/.test(phoneDigits) || phoneDigits.length > 10) {
          return; // Don't update if invalid
        }
        if (phoneDigits.length === 1 && !/^[6-9]$/.test(phoneDigits)) {
          return; // First digit must be 6,7,8,9
        }
      }
    }

    // GST validation
    if (name === 'billTogstin' || name === 'shipTogstin') {
      if (value.length > 15) return; // Don't allow more than 15 characters
      // Convert to uppercase and allow only alphanumeric
      const upperValue = value.toUpperCase().replace(/[^A-Z0-9]/g, '');
      setInvoiceData(prev => ({ ...prev, [name]: upperValue }));

      // If updating billTo field and checkbox is checked, update shipTo field too
      if (sameAsBillTo && name.startsWith('billTo')) {
        const shipToField = name.replace('billTo', 'shipTo');
        setInvoiceData(prev => ({ ...prev, [shipToField]: upperValue }));
      }
      return;
    }

    // Update the main field first
    setInvoiceData(prev => ({ ...prev, [name]: value }));

    // If updating billTo fields and checkbox is checked, update shipTo fields too
    if (sameAsBillTo && name.startsWith('billTo')) {
      const shipToField = name.replace('billTo', 'shipTo');
      setInvoiceData(prev => ({ ...prev, [shipToField]: value }));
    }
  };
  useEffect(() => {
    const totalItemsAmount = parts.reduce(
      (partSum, part) =>
        partSum +
        part.items.reduce((itemSum, item) => itemSum + (parseFloat(item.amount) || 0), 0),
      0
    );

    const cgstPercent = parseFloat(cgstRate) || 0;
    const sgstPercent = parseFloat(sgstRate) || 0;

    const cgstCalculated = totalItemsAmount * (cgstPercent / 100);
    const sgstCalculated = totalItemsAmount * (sgstPercent / 100);

    const total = totalItemsAmount + cgstCalculated + sgstCalculated;

    setInvoiceData(prev => ({
      ...prev,
      subTotal: totalItemsAmount.toFixed(2),
      cgst: cgstCalculated.toFixed(2),
      sgst: sgstCalculated.toFixed(2),
      total: total.toFixed(2),
      balanceDue: total.toFixed(2), // Set balance due equal to total by default
    }));
  }, [parts, cgstRate, sgstRate]);
  useEffect(() => {
    const fetchLastInvoiceNumber = async () => {
      try {
        const response = await axios.get('/last-invoice-number');
        setLastInvoiceNumber(response.data.lastNumber || 0);
      } catch (error) {
        console.error('Error fetching last invoice number:', error);
      }
    };
    fetchLastInvoiceNumber();
  }, []);

  useEffect(() => {
    const newInvoiceNumber = `ETPL/${invoiceData.year}/${String(lastInvoiceNumber + 1).padStart(3, '0')}`;
    setInvoiceData(prev => ({ ...prev, invoiceNumber: newInvoiceNumber }));
  }, [lastInvoiceNumber, invoiceData.year]);

  // useEffect(() => {
  //   const totalItemsAmount = parts.reduce(
  //     (partSum, part) =>
  //       partSum +
  //       part.items.reduce((itemSum, item) => itemSum + (parseFloat(item.amount) || 0), 0),
  //     0
  //   );

  //   const cgstPercent = parseFloat(cgstRate) || 0;
  //   const sgstPercent = parseFloat(sgstRate) || 0;

  //   const cgstCalculated = totalItemsAmount * (cgstPercent / 100);
  //   const sgstCalculated = totalItemsAmount * (sgstPercent / 100);

  //   const total = totalItemsAmount + cgstCalculated + sgstCalculated;

  //   setInvoiceData(prev => ({
  //     ...prev,
  //     subTotal: totalItemsAmount.toFixed(2),
  //     cgst: cgstCalculated.toFixed(2),
  //     sgst: sgstCalculated.toFixed(2),
  //     total: total.toFixed(2),
  //     balanceDue: total.toFixed(2),
  //   }));
  // }, [parts, cgstRate, sgstRate]);
  // Replace your existing total calculation useEffect with this:
  useEffect(() => {
    const totalItemsAmount = parts.reduce(
      (partSum, part) =>
        partSum +
        part.items.reduce((itemSum, item) => itemSum + (parseFloat(item.amount) || 0), 0),
      0
    );

    const cgstPercent = parseFloat(cgstRate) || 0;
    const sgstPercent = parseFloat(sgstRate) || 0;

    const cgstCalculated = totalItemsAmount * (cgstPercent / 100);
    const sgstCalculated = totalItemsAmount * (sgstPercent / 100);

    // Calculate total discount
    const totalDiscountAmount = discounts.reduce(
      (sum, discount) => sum + (parseFloat(discount.amount) || 0),
      0
    );

    // Calculate total after discount
    const subtotalAfterDiscount = totalItemsAmount - totalDiscountAmount;
    const total = subtotalAfterDiscount + cgstCalculated + sgstCalculated;

    setInvoiceData(prev => ({
      ...prev,
      subTotal: totalItemsAmount.toFixed(2),
      totalDiscount: totalDiscountAmount.toFixed(2),
      cgst: cgstCalculated.toFixed(2),
      sgst: sgstCalculated.toFixed(2),
      total: total.toFixed(2),
      balanceDue: total.toFixed(2),
    }));
  }, [parts, cgstRate, sgstRate, discounts]); // Add discounts to dependency array


  const handleCgstRateChange = (e) => {
    const val = e.target.value;
    if (val === '' || /^[0-9]*\.?[0-9]*$/.test(val)) {
      setCgstRate(val);
    }
  };

  const handleSgstRateChange = (e) => {
    const val = e.target.value;
    if (val === '' || /^[0-9]*\.?[0-9]*$/.test(val)) {
      setSgstRate(val);
    }
  };

  const handlePartTitleChange = (index, value) => {
    const newParts = [...parts];
    newParts[index].title = value;
    setParts(newParts);
  };

  const handlePartItemChange = (partIndex, itemIndex, field, value) => {
    const newParts = [...parts];
    if (field === 'amount') {
      // Allow empty string or numbers up to 9 digits with optional decimal
      if (value === '' || /^\d{1,9}(\.\d{0,2})?$/.test(value)) {
        newParts[partIndex].items[itemIndex][field] = value;
        setParts(newParts);
      }
      // If validation fails, don't update the field
      return;
    }
    newParts[partIndex].items[itemIndex][field] = value;
    setParts(newParts);
  };

  const handleAddPartItem = (partIndex) => {
    const newParts = [...parts];
    newParts[partIndex].items.push({ description: '', amount: '' });
    setParts(newParts);
  };

  const handleDeletePartItem = (partIndex, itemIndex) => {
    const newParts = [...parts];
    newParts[partIndex].items.splice(itemIndex, 1);
    setParts(newParts);
  };

  const handleAddNewPart = () => {
    const nextChar = String.fromCharCode(65 + parts.length);
    setParts([...parts, { title: `Part ${nextChar}`, items: [{ description: '', amount: '' }] }]);
  };

  const handleDeletePart = (index) => {
    const newParts = parts.filter((_, i) => i !== index);
    setParts(newParts);
  };
  // Add these handler functions after your existing handlers:

  const handleDiscountChange = (index, field, value) => {
    const newDiscounts = [...discounts];

    if (field === 'amount') {
      // Validate amount field - numbers only up to 9 digits
      if (value === '' || /^\d{1,9}(\.\d{0,2})?$/.test(value)) {
        newDiscounts[index][field] = value;
        setDiscounts(newDiscounts);
      }
      return;
    }

    // For label field, update normally
    newDiscounts[index][field] = value;
    setDiscounts(newDiscounts);
  };

  const handleAddDiscount = () => {
    setDiscounts([...discounts, { label: '', amount: '' }]);
  };

  const handleDeleteDiscount = (index) => {
    const newDiscounts = discounts.filter((_, i) => i !== index);
    setDiscounts(newDiscounts);
  };
//   const previewInvoicePDF = async (invoice) => {
//     try {
//       setPreviewing(invoice._id);

//       const pdf = new jsPDF('p', 'mm', 'a4');
//       const pageWidth = pdf.internal.pageSize.getWidth();
//       const pageHeight = pdf.internal.pageSize.getHeight();

//       // Add custom fonts
//       pdf.addFileToVFS('Verdana.ttf', verdanaFont);
//       pdf.addFont('Verdana.ttf', 'Verdana', 'normal');

//       pdf.addFileToVFS('Verdana-Bold.ttf', verdanaboldFont);
//       pdf.addFont('Verdana-Bold.ttf', 'Verdana', 'bold');

//       pdf.addFileToVFS('NotoSans.ttf', notoSansBase64);
//       pdf.addFont('NotoSans.ttf', 'NotoSans', 'normal');

//       let currentY = 25;

//       // Header Section with Blue Background
//       pdf.setFillColor(0, 81, 255); // Rich blue like in the image
//       pdf.rect(10, 5, pageWidth - 20, 35, 'F');

//       // LOGO on the LEFT
//       try {
//         const logoImg = './image/excerpt.png';
//         pdf.addImage(logoImg, 'PNG', 12, 15, 35, 14);
//       } catch (error) {
//         console.log('Logo not found, using text instead');
//         // Fallback to text logo
//         pdf.setTextColor(255, 255, 255);
//         pdf.setFontSize(20);
//         pdf.setFont('Verdana', 'bold');
//         pdf.text('Excerpt', 12, 25);
//       }

//       // COMPANY TEXT (starts next to logo)
//       const contentX = 60; // space after logo
//       const contentY = 10;

//       pdf.setTextColor(255, 255, 255);
//       pdf.setFont('NotoSans', 'normal');
//       pdf.setFontSize(12);
//       pdf.text('Excerpt Technologies Pvt Ltd', contentX, contentY);

//       pdf.setFont('NotoSans', 'normal');
//       pdf.setFontSize(8);
//       pdf.text('B133/1, 2nd FL, KSSIDC ITI Estate, Whitefield Rd,', contentX, contentY + 5.5);
//       pdf.text('Mahadevpura Post, Bangalore – 560048', contentX, contentY + 9.5);
//       pdf.text('Phone:+91(636) 465 7660, +91 (990) 050 2404 GSTIN:', contentX, contentY + 13.5);
//       pdf.text('29AAGCE2327K1ZH', contentX, contentY + 17.5);
//       pdf.text('LUT No.: AD291021005439D', contentX, contentY + 21.5);

//       // INVOICE TEXT AT FAR RIGHT
//       pdf.setFont('NotoSans', 'bold');
//       pdf.setFontSize(18);
//       pdf.text('INVOICE', pageWidth - 15, contentY + 21.5, { align: 'right' });

//       // Reset for content
//       pdf.setTextColor(0, 0, 0);
//       currentY = 40;

//       pdf.setDrawColor(0, 0, 0);
//       pdf.setLineWidth(0.05);

//       const mainBoxY = currentY;
//       const mainBoxHeight = pageHeight - mainBoxY - 20;
//       pdf.rect(10, mainBoxY, pageWidth - 20, mainBoxHeight);

//       // Invoice Info Container
//       const infoBoxX = 10;
//       const infoBoxWidth = pageWidth - 20;
//       const infoBoxHeight = 30;
//       pdf.rect(infoBoxX, currentY, infoBoxWidth, infoBoxHeight); // Outer border

//       // Split into two columns
//       const midX = infoBoxX + infoBoxWidth / 2;
//       pdf.line(midX, currentY, midX, currentY + infoBoxHeight); // Vertical center line

//       // Left Column
//       pdf.setFontSize(9);
//       pdf.setFont('Verdana', 'normal');
//       pdf.text('Invoice', infoBoxX + 4, currentY + 6);
//       pdf.text('Date', infoBoxX + 4, currentY + 12);
//       pdf.text('Terms', infoBoxX + 4, currentY + 18);
//       pdf.text('Due Date', infoBoxX + 4, currentY + 24);

//       // Values (bold)
//       pdf.setFont('Verdana', 'bold');
//       pdf.text(`: ${invoice.invoiceNumber}`, infoBoxX + 28, currentY + 6);
//       pdf.text(`: ${formatDate(invoice.date)}`, infoBoxX + 28, currentY + 12);
//       pdf.text(`: ${invoice.terms}`, infoBoxX + 28, currentY + 18);
//       pdf.text(`: ${formatDate(invoice.dueDate)}`, infoBoxX + 28, currentY + 24);

//       currentY += infoBoxHeight;



//       const calculateAddressHeight = (billToName, billToCompanyName, billToAddress, billToEmail, billToPhone, billToGstin,
//         shipToName, shipToCompanyName, shipToAddress, shipToEmail, shipToPhone, shipToGstin) => {
//         const baseHeight = 12; // Minimum height for headers
//         const lineHeight = 4;

//         // Calculate lines needed for bill to section
//         let billToLines = 0;
//         if (billToName) billToLines += 1; // Name line
//         if (billToCompanyName) billToLines += 1; // Company name line
//         if (billToAddress) billToLines += billToAddress.split('\n').length; // Address lines
//         if (billToEmail) billToLines += 1; // Email line
//         if (billToPhone) billToLines += 1; // Phone line
//         if (billToGstin) billToLines += 1; // GSTIN line

//         // Calculate lines needed for ship to section
//         let shipToLines = 0;
//         if (shipToName) shipToLines += 1; // Name line
//         if (shipToCompanyName) shipToLines += 1; // Company name line
//         if (shipToAddress) shipToLines += shipToAddress.split('\n').length; // Address lines
//         if (shipToEmail) shipToLines += 1; // Email line
//         if (shipToPhone) shipToLines += 1; // Phone line
//         if (shipToGstin) shipToLines += 1; // GSTIN line

//         // Use the maximum lines needed plus some padding
//         const maxLines = Math.max(billToLines, shipToLines);
//         return Math.max(baseHeight + (maxLines * lineHeight) + 8, 36); // Minimum 36mm height
//       };

//       // Bill To and Ship To sections with dynamic borders
//       const billToX = 10;
//       const shipToX = 105;
//       const sectionWidth = 95;
//       const sectionHeight = calculateAddressHeight(
//         invoice.billToName,
//         invoice.billToCompanyName,
//         invoice.billToAddress,
//         invoice.billToEmail,
//         invoice.billToPhone,
//         invoice.billToGstin,
//         invoice.shipToName,
//         invoice.shipToCompanyName,
//         invoice.shipToAddress,
//         invoice.shipToEmail,
//         invoice.shipToPhone,
//         invoice.shipToGstin
//       );


//       // Draw borders for Bill To and Ship To sections
//       pdf.setDrawColor(0, 0, 0);
//       pdf.setLineWidth(0.1);

//       // Bill To border KARTHIK //
//       // pdf.rect(billToX, currentY, sectionWidth, sectionHeight);
//       pdf.rect(billToX, currentY, sectionWidth * 2, sectionHeight);

//       // pdf.rect(shipToX, currentY, sectionWidth, sectionHeight);
//       pdf.line(shipToX, currentY, shipToX, currentY + sectionHeight);

//       // Headers with background KARTHIK//
//       // pdf.setFillColor(240, 240, 240);
//       // pdf.rect(billToX, currentY, sectionWidth, 8, 'F');
//       // pdf.rect(shipToX, currentY, sectionWidth, 8, 'F');

//       // Header borders
//       pdf.line(billToX, currentY + 6, billToX + sectionWidth, currentY + 6);
//       pdf.line(shipToX, currentY + 6, shipToX + sectionWidth, currentY + 6);

//       // pdf.setFontSize(10);
//       // pdf.setFont('Verdana', 'bold');
//       // pdf.text('Bill To:', billToX + 1, currentY + 3.7);
//       // pdf.text('Ship To:', shipToX + 1, currentY + 3.7);

//       let billToY = currentY + 10;
//       let shipToY = currentY + 10;

//       // Names in bold
//       // pdf.setFontSize(9);
//       // pdf.setFont('Verdana', 'bold');
//       // pdf.text(invoice.billToName.toUpperCase(), billToX + 3, billToY);
//       // pdf.text(invoice.shipToName.toUpperCase(), shipToX + 3, shipToY);

//       billToY += 6;
//       shipToY += 6;

//       // Helper function to wrap text within column width
//       const wrapText = (text, maxWidth) => {
//         const words = text.split(' ');
//         const lines = [];
//         let currentLine = '';

//         for (let word of words) {
//           const testLine = currentLine + (currentLine ? ' ' : '') + word;
//           const testWidth = pdf.getTextWidth(testLine);

//           if (testWidth > maxWidth && currentLine) {
//             lines.push(currentLine);
//             currentLine = word;


//           } else {
//             currentLine = testLine;
//           }
//         }

//         if (currentLine) {
//           lines.push(currentLine);
//         }

//         return lines;
//       };

//       // Bill To Address - properly wrapped
//       pdf.setFont('Verdana', 'normal');
//       // if (invoice.billToAddress) {
//       //   const billToAddressLines = invoice.billToAddress.split('\n');
//       //   const maxTextWidth = sectionWidth - 6;

//       //   for (let line of billToAddressLines) {
//       //     const wrappedLines = wrapText(line, maxTextWidth);
//       //     for (let wrappedLine of wrappedLines) {
//       //       if (billToY < currentY + sectionHeight - 2) {
//       //         pdf.text(wrappedLine, billToX + 3, billToY);
//       //         billToY += 4;
//       //       }
//       //     }
//       //   }
//       // }

//       // // Bill To City
//       // if (invoice.billToCity && billToY < currentY + sectionHeight - 2) {
//       //   const cityLines = wrapText(invoice.billToCity, sectionWidth - 6);
//       //   for (let cityLine of cityLines) {
//       //     if (billToY < currentY + sectionHeight - 2) {
//       //       pdf.text(cityLine, billToX + 3, billToY);
//       //       billToY += 4;
//       //     }
//       //   }
//       // }

//       // Ship To Address - properly wrapped
//       // if (invoice.shipToAddress) {
//       //   const shipToAddressLines = invoice.shipToAddress.split('\n');

//       //   for (let line of shipToAddressLines) {
//       //     const wrappedLines = wrapText(line, sectionWidth - 6);
//       //     for (let wrappedLine of wrappedLines) {
//       //       if (shipToY < currentY + sectionHeight - 2) {
//       //         pdf.text(wrappedLine, shipToX + 3, shipToY);
//       //         shipToY += 4;
//       //       }
//       //     }
//       //   }
//       // }

//       // // Ship To City
//       // if (invoice.shipToCity && shipToY < currentY + sectionHeight - 2) {
//       //   const cityLines = wrapText(invoice.shipToCity, sectionWidth - 6);
//       //   for (let cityLine of cityLines) {
//       //     if (shipToY < currentY + sectionHeight - 2) {
//       //       pdf.text(cityLine, shipToX + 3, shipToY);
//       //       shipToY += 4;
//       //     }
//       //   }
//       // }
//       pdf.setFont('helvetica', 'bold');
//       pdf.setFontSize(10);
//       pdf.text('BILL TO', billToX + 2, currentY + 4);
//       pdf.text('SHIP TO', shipToX + 2, currentY + 4);

//       // Function to render address section content
//       const renderAddressSection = (x, name, companyName, address, email, phone, gstin) => {
//         let yOffset = currentY + 10; // Start below header

//         // Name (first line)
//         if (name) {
//           pdf.setFont('helvetica', 'bold');
//           pdf.setFontSize(10);
//           pdf.text(name, x + 2, yOffset);
//           yOffset += 5;
//         }

//         // Company name (second line, bold)
//         if (companyName) {
//           pdf.setFont('helvetica', 'bold');
//           pdf.setFontSize(10);
//           pdf.text(companyName, x + 2, yOffset);
//           yOffset += 5;
//         }

//         // Address
//         if (address) {
//           pdf.setFont('helvetica', 'normal');
//           pdf.setFontSize(9);
//           const addressLines = address.split('\n');
//           addressLines.forEach(line => {
//             if (line.trim()) {
//               pdf.text(line.trim(), x + 2, yOffset);
//               yOffset += 5;
//             }
//           });
//         }

//         // Email
//         if (email) {
//           pdf.setFont('helvetica', 'normal');
//           pdf.setFontSize(9);
//           pdf.text(`${email}`, x + 2, yOffset);
//           yOffset += 5;
//         }

//         // Phone
//         if (phone) {
//           pdf.setFont('helvetica', 'normal');
//           pdf.setFontSize(9);
//           pdf.text(`${phone}`, x + 2, yOffset);
//           yOffset += 5;
//         }

//         // GSTIN
//         if (gstin) {
//           pdf.setFont('helvetica', 'normal');
//           pdf.setFontSize(9);
//           pdf.text(`${gstin}`, x + 2, yOffset);
//           yOffset += 5;
//         }
//       };

//       // Render Bill To section
//       renderAddressSection(
//         billToX,
//         invoice.billToName,
//         invoice.billtocompanyname,


//         invoice.billToAddress,
//         invoice.billToemail,
//         invoice.billTophone,
//         invoice.billTogstin
//       );

//       // Render Ship To section
//       renderAddressSection(
//         shipToX,
//         invoice.shipToName,
//         invoice.shipTocompanyname,
//         invoice.shipToAddress,
//         invoice.shipToemail,
//         invoice.shipTophone,
//         invoice.shipTogstin
//       );

//       // Update currentY to move past the address sections
//       currentY += sectionHeight;
//       // Move currentY to after the Bill To/Ship To sections


//       // Items table
//       const tableStartY = currentY;
//       const tableStartX = 10;
//       const tableWidth = pageWidth - 20;
//       const descriptionWidth = tableWidth - 50;
//       const amountWidth = 50;

//       // Table header with proper styling
//       pdf.setFillColor(230, 230, 230);
//       pdf.rect(tableStartX, tableStartY, tableWidth, 10, 'F');
//       pdf.setDrawColor(0, 0, 0);
//       pdf.setLineWidth(0.1);

//       // Draw table header borders
//       pdf.rect(tableStartX, tableStartY, tableWidth, 10);
//       pdf.line(tableStartX + descriptionWidth, tableStartY, tableStartX + descriptionWidth, tableStartY + 10);

//       pdf.setFontSize(10);
//       pdf.setFont('Verdana', 'bold');
//       pdf.setTextColor(0, 0, 0);
//       pdf.text('Items & Description', tableStartX + 3, tableStartY + 7);
//       pdf.text('Amount', tableStartX + descriptionWidth + 18, tableStartY + 7);

//       currentY = tableStartY + 10;

//       // Table rows
//       let rowNumber = 1;
//       const rowHeight = 8;

//       if (invoice.parts) {
//         invoice.parts.forEach((part, partIndex) => {
//           // Part title row with gray background
//           pdf.setFillColor(220, 220, 220);
//           pdf.rect(tableStartX, currentY, tableWidth, rowHeight, 'F');

//           // Draw borders
//           pdf.setDrawColor(0, 0, 0);
//           pdf.rect(tableStartX, currentY, tableWidth, rowHeight);
//           pdf.line(tableStartX + descriptionWidth, currentY, tableStartX + descriptionWidth, currentY + rowHeight);

//           pdf.setFontSize(9);
//           pdf.setFont('Verdana', 'bold');
//           pdf.setTextColor(0, 0, 0);
//           pdf.text(part.title, tableStartX + 3, currentY + 5.5);

//           currentY += rowHeight;

//           // Part items
//           if (part.items) {
//             part.items.forEach((item, itemIndex) => {
//               // Row background
//               pdf.setFillColor(255, 255, 255);
//               pdf.rect(tableStartX, currentY, tableWidth, rowHeight, 'F');

//               // Draw borders
//               pdf.setDrawColor(0, 0, 0);
//               pdf.rect(tableStartX, currentY, tableWidth, rowHeight);
//               pdf.line(tableStartX + descriptionWidth, currentY, tableStartX + descriptionWidth, currentY + rowHeight);

//               pdf.setFontSize(9);
//               pdf.setFont('Verdana', 'normal');
//               pdf.setTextColor(0, 0, 0);

//               // Item description with proper numbering
//               const description = `${rowNumber}. ${item.description}`;
//               pdf.text(description, tableStartX + 3, currentY + 5.5);

//               // Amount - right aligned within amount column
//               pdf.setFont('NotoSans', 'normal');
//               const amountText = formatCurrency(item.amount);
//               const amountX = tableStartX + descriptionWidth + amountWidth - 3 - pdf.getTextWidth(amountText);
//               pdf.text(amountText, amountX, currentY + 5.5);

//               currentY += rowHeight;
//               rowNumber++;
//             });
//           }
//         });
//       }

//       // Close table with bottom border
//       pdf.setDrawColor(0, 0, 0);
//       pdf.line(tableStartX, currentY, tableStartX + tableWidth, currentY);

//       currentY += 8;

//       const leftColumnX = 15;
//       const maxTextWidth = 70;
//       const rightColumnX = pageWidth - 95;
//       const rightColumnWidth = 83;

//       // Total in Words (Left side)
//       pdf.setFontSize(10);
//       pdf.setFont('Verdana', 'bold');
//       pdf.text('Total In Words:', leftColumnX, currentY);

//       pdf.setFontSize(9);
//       pdf.setFont('Verdana', 'normal');
//       const totalInWords = convertNumberToWords(invoice.total);
//       const wrappedText = pdf.splitTextToSize(totalInWords, maxTextWidth);
//       pdf.text(wrappedText, leftColumnX, currentY + 6);

//       // Draw vertical and horizontal lines for the right column
//       pdf.line(pageWidth / 1.5, currentY - 8, pageWidth / 1.5, currentY + 58);
//       pdf.line(pageWidth / 1.5, currentY + 58, pageWidth - 10, currentY + 58);

//       // Totals Section (Right side)
//       pdf.setFontSize(9);
//       let rightY = currentY;

//       // Sub Total
//       pdf.setFont('Verdana', 'normal');
//       pdf.text('Sub Total:', rightColumnX + 30, rightY);
//       pdf.setFont('NotoSans', 'normal');
//       const subTotalText = formatCurrency(invoice.subTotal);
//       pdf.text(subTotalText, rightColumnX + rightColumnWidth - pdf.getTextWidth(subTotalText), rightY);

//       // CGST
//       rightY += 6;
//       pdf.setFont('Verdana', 'normal');
//       pdf.text(`CGST (${invoice.cgstRate || 0}%):`, rightColumnX + 30, rightY);
//       pdf.setFont('NotoSans', 'normal');
//       const cgstText = formatCurrency(invoice.cgst || 0);
//       pdf.text(cgstText, rightColumnX + rightColumnWidth - pdf.getTextWidth(cgstText), rightY);

//       // SGST
//       rightY += 6;
//       pdf.setFont('Verdana', 'normal');
//       pdf.text(`SGST (${invoice.sgstRate || 0}%):`, rightColumnX + 30, rightY);
//       pdf.setFont('NotoSans', 'normal');
//       const sgstText = formatCurrency(invoice.sgst || 0);
//       pdf.text(sgstText, rightColumnX + rightColumnWidth - pdf.getTextWidth(sgstText), rightY);
//       rightY += 6;
//       pdf.setFont('Verdana', 'normal');
//       pdf.text(`Discount :`, rightColumnX + 30, rightY);
//       pdf.setFont('NotoSans', 'normal');
//       const totalDiscount = formatCurrency(invoice.totalDiscount || 0);
//       pdf.text(totalDiscount, rightColumnX + rightColumnWidth - pdf.getTextWidth(sgstText), rightY);

//       // Total (Bold value)
//       rightY += 6;
//       pdf.setFont('Verdana', 'bold');
//       pdf.text('Total:', rightColumnX + 30, rightY);
//       pdf.setFont('NotoSans', 'normal');

//       // Simulate bold for rupee value
//       const totalText = formatCurrency(invoice.total);
//       for (let i = 0; i < 2; i++) {
//         pdf.text(totalText, rightColumnX + rightColumnWidth - pdf.getTextWidth(totalText) + i * 0.2, rightY);
//       }

//       // Balance Due (Bold value)
//       rightY += 6;
//       pdf.setFont('Verdana', 'bold');
//       pdf.text('Balance Due:', rightColumnX + 30, rightY);
//       pdf.setFont('NotoSans', 'normal');
//       const balanceText = formatCurrency(invoice.balanceDue || invoice.total);
//       for (let i = 0; i < 2; i++) {
//         pdf.text(balanceText, rightColumnX + rightColumnWidth - pdf.getTextWidth(balanceText) + i * 0.2, rightY);
//       }

//       currentY += 25;

//       // Thank you message
//       pdf.setFontSize(9);
//       pdf.setFont('Verdana', 'normal');
//       pdf.text('Thank you for the valuable business! We will always be at', 15, currentY);
//       pdf.text('your desk to support you.', 15, currentY + 5);

//       // Authorized signature section with seal and signature images
//       const signatureY = currentY + 15;
//       pdf.line(pageWidth / 1.5, currentY, pageWidth - 10, currentY);

//       // Add signature image if available
//       try {
//         const signatureImg = './image/sign.jpeg';
//         pdf.addImage(signatureImg, 'JPEG', rightColumnX + 55, signatureY - 10, 20, 15);
//       } catch (error) {
//         console.log('Signature image not found');
//       }

//       // Add company seal if available
//       try {
//         const sealImg = './image/seal.jpeg';
//         pdf.addImage(sealImg, 'JPEG', rightColumnX + 30, signatureY - 13, 20, 20);
//       } catch (error) {
//         console.log('Seal image not found');
//       }

//       // Scanner image (QR code) if available
//       try {
//         const scannerImg = './image/scanner.png';
//         pdf.addImage(scannerImg, 'PNG', rightColumnX + 40, signatureY + 21, 25, 25);
//       } catch (error) {
//         console.log('Scanner image not found');
//       }

//       pdf.setFontSize(7);
//       pdf.setFont('Verdana', 'normal');
//       pdf.text('Authorized Signature', rightColumnX + 50, signatureY + 5);

//       currentY = signatureY - 5;
//       currentY += 6;

//       pdf.setFontSize(8);
//       pdf.setFont('Verdana', 'bold');
//       pdf.text('Terms & Conditions:', 15, currentY);

//       pdf.setFont('Verdana', 'normal');
//       currentY += 5;

//       // Use dynamic terms and conditions from invoice data
//       const termsAndConditions = invoice.termsAndConditions || 'Full payment is due upon receipt of this invoice. Late payment may incur additional charges as per the applicable rates.';
//       const termsLines = wrapText(termsAndConditions, pageWidth - 140);
//       termsLines.forEach((line, index) => {
//         pdf.text(line, 15, currentY + (index * 4));
//       });
//       currentY += Math.max(termsLines.length * 4, 8); // Minimum spacing

//       currentY += 5;
//       // Bank Details
//       pdf.setFontSize(8);
//       pdf.setFont('Verdana', 'bold');
//       pdf.text('Our Bank Details:', 15, currentY);
//       currentY += 5;

//       pdf.setFont('Verdana', 'normal');
//       // Use dynamic bank details from invoice data
//       const bankDetails = invoice.bankDetails || `Name: Excerpt Technologies Private Limited
// Account Number: 10063739760
// Name of Bank: IDFC First Bank
// IFSC Code: IDFB0080151
// PAN No: AAGCE2327K`;

//       const bankDetailsLines = bankDetails.split('\n');
//       bankDetailsLines.forEach((line, index) => {
//         pdf.text(line, 15, currentY + (index * 4));
//       });

//       currentY += bankDetailsLines.length * 4;

//       pdf.setFontSize(8);
//       pdf.setTextColor(0, 0, 255);
//       pdf.text('https://excerptech.com', 15, currentY + 30);
//       pdf.setTextColor(0, 0, 0);
//       pdf.text('E-mail: info@excerptech.com', pageWidth - 65, currentY + 30);

//       // Generate PDF data URL for preview instead of downloading
//       const pdfDataUri = pdf.output('datauristring');

//       // Open PDF in new tab for preview
//       const newWindow = window.open();
//       newWindow.document.write(`
//       <html>
//         <head>
//           <title>Invoice Preview - ${invoice.invoiceNumber}</title>
//           <style>
//             body { margin: 0; padding: 0; }
//             iframe { width: 100%; height: 100vh; border: none; }
//           </style>
//         </head>
//         <body>
//           <iframe src="${pdfDataUri}"></iframe>
//         </body>
//       </html>
//     `);

//     } catch (error) {
//       console.error('Error generating PDF preview:', error);
//       alert('Error generating PDF preview. Please try again.');
//     } finally {
//       setPreviewing(null);
//     }
//   };
    const previewInvoicePDF = async (invoice) => {
      try {
       setPreviewing(invoice._id); // You'll need this state: const [previewLoading,setPreviewing] = useState(null);
  
        const pdf = new jsPDF('p', 'mm', 'a4');
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();
  
        // Add custom fonts
        pdf.addFileToVFS('Verdana.ttf', verdanaFont);
        pdf.addFont('Verdana.ttf', 'Verdana', 'normal');
  
        pdf.addFileToVFS('Verdana-Bold.ttf', verdanaboldFont);
        pdf.addFont('Verdana-Bold.ttf', 'Verdana', 'bold');
  
        pdf.addFileToVFS('NotoSans.ttf', notoSansBase64);
        pdf.addFont('NotoSans.ttf', 'NotoSans', 'normal');
  
        let currentY = 25;
  
        // Header Section with Blue Background - exact match
        // pdf.setFillColor(59, 130, 246); // Blue color
        // pdf.rect(200, 100, pageWidth, 35, 'F');
  
        // HEADER BACKGROUND
  
        pdf.setFillColor(0, 81, 255); // Rich blue like in the image
        pdf.rect(10, 5, pageWidth - 20, 28, 'F');
  
        // LOGO on the LEFT
        try {
          const logoImg = './image/excerpt.png';
          pdf.addImage(logoImg, 'PNG', 12, 12, 35, 14);
        } catch (error) {
          console.log('Logo not found, using text instead');
          // Fallback to text logo
          pdf.setTextColor(255, 255, 255);
          pdf.setFontSize(20);
          pdf.setFont('Verdana', 'bold');
          pdf.text('Excerpt', 12, 25);
        }
  
        // COMPANY TEXT (starts next to logo)
        const contentX = 60; // space after logo
        const contentY = 9;
  
        pdf.setTextColor(255, 255, 255);
        pdf.setFont('NotoSans', 'normal');
        pdf.setFontSize(12);
        pdf.text('Excerpt Technologies Pvt Ltd', contentX, contentY);
  
        pdf.setFont('NotoSans', 'normal');
        pdf.setFontSize(8);
        pdf.text('B133/1, 2nd FL, KSSIDC ITI Estate, Whitefield Rd,', contentX, contentY + 5.5);
        pdf.text('Mahadevpura Post, Bangalore – 560048', contentX, contentY + 9.5);
        pdf.text('Phone:+91(636) 465 7660, +91 (990) 050 2404 ', contentX, contentY + 13.5);
        pdf.text('GSTIN:29AAGCE2327K1ZH', contentX, contentY + 17.5);
        pdf.text('LUT No.: AD291021005439D', contentX, contentY + 21.5);
  
        // INVOICE TEXT AT FAR RIGHT
        pdf.setFont('NotoSans', 'bold');
        pdf.setFontSize(18);
        pdf.text('INVOICE', pageWidth - 15, contentY + 15.5, { align: 'right' });
  
        // Reset for content
        pdf.setTextColor(0, 0, 0);
        currentY = 30;
  
  
  
        pdf.setDrawColor(0, 0, 0);
  
        pdf.setLineWidth(0.05);
  
        // pdf.rect(10, currentY, pageWidth - 20, pageHeight - currentY - 20); kARTHIK
        const mainBoxY = currentY;
        const mainBoxHeight = pageHeight - mainBoxY - 20;
        pdf.rect(10, mainBoxY + 3, pageWidth - 20, mainBoxHeight);
  
  
  
  
        // Invoice details section KARTHIK//
        // currentY += 7;
        // pdf.setFontSize(9);
        // pdf.setFont('Verdana', 'normal');
  
        // pdf.text('Invoice:', 15, currentY);
        // pdf.setFont('Verdana', 'bold');
        // pdf.text(invoice.invoiceNumber, 35, currentY);
  
        // pdf.setFont('Verdana', 'normal');
        // pdf.text('Date:', 15, currentY + 6);
        // pdf.setFont('Verdana', 'bold');
        // pdf.text(formatDate(invoice.date), 35, currentY + 6);
  
        // pdf.setFont('Verdana', 'normal');
        // pdf.text('Terms:', 15, currentY + 12);
        // pdf.setFont('Verdana', 'bold');
        // pdf.text(invoice.terms, 35, currentY + 12);
  
        // pdf.setFont('Verdana', 'normal');
        // pdf.text('Due Date:', 15, currentY + 18);
        // pdf.setFont('Verdana', 'bold');
        // pdf.text(formatDate(invoice.dueDate), 35, currentY + 18);
  
  
  
  
  
        // Invoice Info Container
        const infoBoxX = 10;
        const infoBoxWidth = pageWidth - 20;
        const infoBoxHeight = 22;
        pdf.rect(infoBoxX, currentY + 3, infoBoxWidth, infoBoxHeight); // Outer border
  
        // Split into two columns
        const midX = infoBoxX + infoBoxWidth / 2;
        pdf.line(midX, currentY + 3, midX, currentY + infoBoxHeight + 3); // Vertical center line
  
        // Left Column
        pdf.setFontSize(8);
        pdf.setFont('Verdana', 'normal');
        pdf.text('Invoice', infoBoxX + 4, currentY + 7);
        pdf.text('Date', infoBoxX + 4, currentY + 12);
        pdf.text('Terms', infoBoxX + 4, currentY + 17);
        pdf.text('Due Date', infoBoxX + 4, currentY + 22);
  
        // Values (bold)
        pdf.setFont('Verdana', 'bold');
        pdf.text(`: ${invoice.invoiceNumber}`, infoBoxX + 28, currentY + 7);
        pdf.text(`: ${formatDate(invoice.date)}`, infoBoxX + 28, currentY + 12);
        pdf.text(`: ${invoice.terms}`, infoBoxX + 28, currentY + 17);
        pdf.text(`: ${formatDate(invoice.dueDate)}`, infoBoxX + 28, currentY + 22);
  
        // Right Column (blank or for future use if needed)
        // You can fill it if required
  
  
        currentY += infoBoxHeight + 3;
  
  
  
        const calculateAddressHeight = (billToName, billToCompanyName, billToAddress, billToEmail, billToPhone, billToGstin,
          shipToName, shipToCompanyName, shipToAddress, shipToEmail, shipToPhone, shipToGstin) => {
          const baseHeight = 12; // Minimum height for headers
          const lineHeight = 4;
  
          // Calculate lines needed for bill to section
          let billToLines = 0;
          if (billToName) billToLines += 1; // Name line
          if (billToCompanyName) billToLines += 1; // Company name line
          if (billToAddress) billToLines += billToAddress.split('\n').length; // Address lines
          if (billToEmail) billToLines += 1; // Email line
          if (billToPhone) billToLines += 1; // Phone line
          if (billToGstin) billToLines += 1; // GSTIN line
  
          // Calculate lines needed for ship to section
          let shipToLines = 0;
          if (shipToName) shipToLines += 1; // Name line
          if (shipToCompanyName) shipToLines += 1; // Company name line
          if (shipToAddress) shipToLines += shipToAddress.split('\n').length; // Address lines
          if (shipToEmail) shipToLines += 1; // Email line
          if (shipToPhone) shipToLines += 1; // Phone line
          if (shipToGstin) shipToLines += 1; // GSTIN line
  
          // Use the maximum lines needed plus some padding
          const maxLines = Math.max(billToLines, shipToLines);
          return Math.max(baseHeight + (maxLines * lineHeight) + 8, 36); // Minimum 36mm height
        };
  
        // Bill To and Ship To sections with dynamic borders
        const billToX = 10;
        const shipToX = 105;
        const sectionWidth = 95;
        const sectionHeight = calculateAddressHeight(
          invoice.billToName,
          invoice.billToCompanyName,
          invoice.billToAddress,
          invoice.billToEmail,
          invoice.billToPhone,
          invoice.billToGstin,
          invoice.shipToName,
          invoice.shipToCompanyName,
          invoice.shipToAddress,
          invoice.shipToEmail,
          invoice.shipToPhone,
          invoice.shipToGstin
        );
  
  
        // Draw borders for Bill To and Ship To sections
        pdf.setDrawColor(0, 0, 0);
        pdf.setLineWidth(0.1);
        pdf.setFillColor(220, 220, 220);
        // Bill To border KARTHIK //
        // pdf.rect(billToX, currentY, sectionWidth, sectionHeight);
  
        pdf.rect(billToX, currentY, sectionWidth * 2, sectionHeight);
  
        // pdf.rect(shipToX, currentY, sectionWidth, sectionHeight);
        pdf.line(shipToX, currentY, shipToX, currentY + sectionHeight);
  
        // Headers with background KARTHIK//
  
        pdf.rect(billToX + 0.1, currentY + 0.5, sectionWidth - 0.6, 4, 'F');
        pdf.rect(shipToX + 0.1, currentY + 0.5, sectionWidth - 0.6, 4, 'F');
  
        // Header borders
  
        pdf.line(billToX, currentY + 4, billToX + sectionWidth, currentY + 4);
        pdf.line(shipToX, currentY + 4, shipToX + sectionWidth, currentY + 4);
  
        // pdf.setFontSize(10);
        // pdf.setFont('Verdana', 'bold');
        // pdf.text('Bill To:', billToX + 1, currentY + 3.7);
        // pdf.text('Ship To:', shipToX + 1, currentY + 3.7);
  
        let billToY = currentY + 10;
        let shipToY = currentY + 10;
  
        // Names in bold
        // pdf.setFontSize(9);
        // pdf.setFont('Verdana', 'bold');
        // pdf.text(invoice.billToName.toUpperCase(), billToX + 3, billToY);
        // pdf.text(invoice.shipToName.toUpperCase(), shipToX + 3, shipToY);
  
        billToY += 6;
        shipToY += 6;
  
        // Helper function to wrap text within column width
        const wrapText = (text, maxWidth) => {
          const words = text.split(' ');
          const lines = [];
          let currentLine = '';
  
          for (let word of words) {
            const testLine = currentLine + (currentLine ? ' ' : '') + word;
            const testWidth = pdf.getTextWidth(testLine);
  
            if (testWidth > maxWidth && currentLine) {
              lines.push(currentLine);
              currentLine = word;
  
  
            } else {
              currentLine = testLine;
            }
          }
  
          if (currentLine) {
            lines.push(currentLine);
          }
  
          return lines;
        };
  
        // Bill To Address - properly wrapped
        pdf.setFont('Verdana', 'normal');
        // if (invoice.billToAddress) {
        //   const billToAddressLines = invoice.billToAddress.split('\n');
        //   const maxTextWidth = sectionWidth - 6;
  
        //   for (let line of billToAddressLines) {
        //     const wrappedLines = wrapText(line, maxTextWidth);
        //     for (let wrappedLine of wrappedLines) {
        //       if (billToY < currentY + sectionHeight - 2) {
        //         pdf.text(wrappedLine, billToX + 3, billToY);
        //         billToY += 4;
        //       }
        //     }
        //   }
        // }
  
        // // Bill To City
        // if (invoice.billToCity && billToY < currentY + sectionHeight - 2) {
        //   const cityLines = wrapText(invoice.billToCity, sectionWidth - 6);
        //   for (let cityLine of cityLines) {
        //     if (billToY < currentY + sectionHeight - 2) {
        //       pdf.text(cityLine, billToX + 3, billToY);
        //       billToY += 4;
        //     }
        //   }
        // }
  
        // Ship To Address - properly wrapped
        // if (invoice.shipToAddress) {
        //   const shipToAddressLines = invoice.shipToAddress.split('\n');
  
        //   for (let line of shipToAddressLines) {
        //     const wrappedLines = wrapText(line, sectionWidth - 6);
        //     for (let wrappedLine of wrappedLines) {
        //       if (shipToY < currentY + sectionHeight - 2) {
        //         pdf.text(wrappedLine, shipToX + 3, shipToY);
        //         shipToY += 4;
        //       }
        //     }
        //   }
        // }
  
        // // Ship To City
        // if (invoice.shipToCity && shipToY < currentY + sectionHeight - 2) {
        //   const cityLines = wrapText(invoice.shipToCity, sectionWidth - 6);
        //   for (let cityLine of cityLines) {
        //     if (shipToY < currentY + sectionHeight - 2) {
        //       pdf.text(cityLine, shipToX + 3, shipToY);
        //       shipToY += 4;
        //     }
        //   }
        // }
  
  
        pdf.setFont('helvetica', 'bold');
        pdf.setFontSize(7);
        pdf.setFillColor(230, 230, 230);
  
        pdf.text('Bill To', billToX + 2, currentY + 3);
        pdf.text('Ship To', shipToX + 2, currentY + 3);
  
        // Function to render address section content
        const renderAddressSection = (x, name, companyName, address, email, phone, gstin) => {
          let yOffset = currentY + 8; // Start below header
  
          // Name (first line)
          if (name) {
            pdf.setFont('helvetica', 'bold');
            pdf.setFontSize(10);
            pdf.text(name, x + 2, yOffset);
            yOffset += 5;
          }
  
          // Company name (second line, bold)
          if (companyName) {
            pdf.setFont('helvetica', 'bold');
            pdf.setFontSize(10);
            pdf.text(companyName, x + 2, yOffset);
            yOffset += 5;
          }
  
          // Address
          if (address) {
            pdf.setFont('helvetica', 'normal');
            pdf.setFontSize(7);
            const maxLineWidth = 80; // Adjust as per your layout
            const addressLines = address.split('\n');
  
            addressLines.forEach(line => {
              if (line.trim()) {
                const wrappedLines = pdf.splitTextToSize(line.trim(), maxLineWidth);
                wrappedLines.forEach(wrappedLine => {
                  pdf.text(wrappedLine, x + 2, yOffset);
                  yOffset += 4;
                });
              }
            });
          }
  
  
          // Email
          if (email) {
            pdf.setFont('helvetica', 'normal');
            pdf.setFontSize(7);
            pdf.text(`EMAIL: ${email}`, x + 2, yOffset);
            yOffset += 4;
          }
  
          // Phone
          if (phone) {
            pdf.setFont('helvetica', 'normal');
            pdf.setFontSize(7);
            pdf.text(`PHONE: ${phone}`, x + 2, yOffset);
            yOffset += 4;
          }
  
          // GSTIN
          if (gstin) {
            pdf.setFont('helvetica', 'normal');
            pdf.setFontSize(7);
            pdf.text(`GSTN: ${gstin}`, x + 2, yOffset);
            yOffset += 4;
          }
        };
  
        // Render Bill To section
        renderAddressSection(
          billToX,
          invoice.billToName,
          invoice.billtocompanyname,
  
  
          invoice.billToAddress,
          invoice.billToemail,
          invoice.billTophone,
          invoice.billTogstin
        );
  
        // Render Ship To section
        renderAddressSection(
          shipToX,
          invoice.shipToName,
          invoice.shipTocompanyname,
          invoice.shipToAddress,
          invoice.shipToemail,
          invoice.shipTophone,
          invoice.shipTogstin
        );
  
        // Update currentY to move past the address sections
        currentY += sectionHeight;
        // Move currentY to after the Bill To/Ship To sections
  
  
        // Items table - FIXED VERSION
        const tableStartY = currentY;
        const tableStartX = 10;
        const tableWidth = pageWidth - 20;
        const descriptionWidth = tableWidth - 50;
        const amountWidth = 50;
  
        // Table header with proper styling
        pdf.setFillColor(230, 230, 230);
        pdf.rect(tableStartX, tableStartY, tableWidth, 6, 'F');
        pdf.setDrawColor(0, 0, 0);
        pdf.setLineWidth(0.1);
  
        // Draw table header borders
        pdf.rect(tableStartX, tableStartY, tableWidth, 6);
        pdf.line(tableStartX + descriptionWidth + 20, tableStartY, tableStartX + descriptionWidth + 20, tableStartY + 10);
  
        pdf.setFontSize(8);
        pdf.setFont('Verdana', 'bold');
        pdf.setTextColor(0, 0, 0);
        pdf.text('Items & Description', tableStartX + 3, tableStartY + 4);
        pdf.text('Amount', tableStartX + descriptionWidth + 30, tableStartY + 4);
  
  
  
        currentY = tableStartY + (5);
  
        // Table rows - COMPLETELY REWRITTEN for proper formatting
        let rowNumber = 1;
        const rowHeight = 7;
  
        if (invoice.parts) {
          invoice.parts.forEach((part, partIndex) => {
            // Part title row with gray background
            pdf.setFillColor(220, 220, 220);
            pdf.rect(tableStartX, currentY, tableWidth, rowHeight, 'F');
  
            // Draw borders
            pdf.setDrawColor(0, 0, 0);
            pdf.rect(tableStartX, currentY, tableWidth, rowHeight);
            pdf.line(tableStartX + descriptionWidth + 20, currentY, tableStartX + descriptionWidth + 20, currentY + rowHeight);
  
            pdf.setFontSize(8);
            pdf.setFont('Verdana', 'bold');
            pdf.setTextColor(0, 0, 0);
            pdf.text(part.title, tableStartX + 3, currentY + 4.5);
  
            currentY += rowHeight - 1;
  
            // Part items
            if (part.items) {
              part.items.forEach((item, itemIndex) => {
                // Row background
                pdf.setFillColor(255, 255, 255);
                pdf.rect(tableStartX, currentY, tableWidth, rowHeight, 'F');
  
                // Draw borders
                pdf.setDrawColor(0, 0, 0);
                pdf.rect(tableStartX, currentY, tableWidth, rowHeight);
                pdf.line(tableStartX + descriptionWidth + 20, currentY, tableStartX + descriptionWidth + 20, currentY + rowHeight);
                pdf.line(tableStartX + 7, currentY, tableStartX + 7, currentY + rowHeight);
                pdf.setFontSize(9);
                pdf.setFont('Verdana', 'normal');
                pdf.setTextColor(0, 0, 0);
  
                // Item description with proper numbering
                const description = `${rowNumber}.   ${item.description}`;
                pdf.text(description, tableStartX + 2, currentY + 5.5);
  
                // Amount - right aligned within amount column
                pdf.setFont('NotoSans', 'normal');
                const amountText = formatCurrency(item.amount);
                const amountX = tableStartX + descriptionWidth + amountWidth - 3 - pdf.getTextWidth(amountText);
                pdf.text(amountText, amountX, currentY + 5.5);
  
                currentY += rowHeight;
                rowNumber++;
              });
            }
          });
        }
  
        // Close table with bottom border
        pdf.setDrawColor(0, 0, 0);
        pdf.line(tableStartX, currentY, tableStartX + tableWidth, currentY);
  
  
  
        currentY += 8;
  
        // // Create a two-column layout for totals section KARTHIK
        // const leftColumnX = 15;
        // const maxTextWidth = 70;
        // const rightColumnX = pageWidth - 95; // Adjusted for better alignment
        // const rightColumnWidth = 80;
  
        // // Total in words (left side)
        // pdf.setFontSize(10);
        // pdf.setFont('Verdana', 'bold');
        // pdf.text('Total In Words:', leftColumnX , currentY);
  
        // pdf.setFontSize(9);
        // pdf.setFont('Verdana', 'normal');
  
        // const totalInWords = convertNumberToWords(invoice.total);
        // const wrappedText = pdf.splitTextToSize(totalInWords, maxTextWidth);
  
        // pdf.text(wrappedText, leftColumnX, currentY + 6);
  
        // // Totals section (right side) - Fixed alignment
        // pdf.setFontSize(9);
        // pdf.line(pageWidth/1.5, (pageHeight/2)+7, pageWidth/1.5, pageHeight-100);
        //  pdf.line(pageWidth/1.5, pageHeight-100, pageWidth-10, pageHeight-100);
        // // Sub Total
        // pdf.setFont('Verdana', 'normal');
        // pdf.text('Sub Total:', rightColumnX +30, currentY);
        // pdf.setFont('NotoSans', 'normal');
        // const subTotalText = formatCurrency(invoice.subTotal);
        // pdf.text(subTotalText, rightColumnX + rightColumnWidth - pdf.getTextWidth(subTotalText), currentY);
  
        // // CGST
        // pdf.setFont('Verdana', 'normal');
        // pdf.text(`CGST (${invoice.cgstRate || 0}%):`, rightColumnX +30, currentY + 6);
        // pdf.setFont('NotoSans', 'normal');
        // const cgstText = formatCurrency(invoice.cgst || 0);
        // pdf.text(cgstText, rightColumnX + rightColumnWidth - pdf.getTextWidth(cgstText), currentY + 6);
  
        // // SGST
        // pdf.setFont('Verdana', 'normal');
        // pdf.text(`SGST (${invoice.sgstRate || 0}%):`, rightColumnX +30, currentY + 12);
        // pdf.setFont('NotoSans', 'normal');
        // const sgstText = formatCurrency(invoice.sgst || 0);
        // pdf.text(sgstText, rightColumnX + rightColumnWidth - pdf.getTextWidth(sgstText), currentY + 12);
  
        // // Total
        // pdf.setFont('Verdana', 'bold');
        // pdf.text('Total:', rightColumnX +30, currentY + 18);
        // pdf.setFont('NotoSans', 'normal');
        // const totalText = formatCurrency(invoice.total);
        // pdf.text(totalText, rightColumnX + rightColumnWidth - pdf.getTextWidth(totalText), currentY + 18);
  
        // // Balance Due
        // pdf.setFont('Verdana', 'bold');
        // pdf.text('Balance Due:', rightColumnX +30, currentY + 24);
        // pdf.setFont('NotoSans', 'normal');
        // const balanceText = formatCurrency(invoice.balanceDue || invoice.total);
        // pdf.text(balanceText, rightColumnX + rightColumnWidth - pdf.getTextWidth(balanceText), currentY + 24);
  
  
  
  
        const leftColumnX = 15;
        const maxTextWidth = 120;
        const rightColumnX = pageWidth - 95;
        const rightColumnWidth = 83;
  
        // Total in Words (Left side)
        pdf.setFontSize(10);
        pdf.setFont('Verdana', 'bold');
        pdf.text('Total In Words:', leftColumnX, currentY);
  
        pdf.setFontSize(10);
        // pdf.setFont('Verdana', 'bold');
        pdf.setFont('NotoSans', 'bolditalic');
        const totalInWords = convertNumberToWords(invoice.total);
        const wrappedText = pdf.splitTextToSize(totalInWords, maxTextWidth);
        pdf.text(wrappedText, leftColumnX, currentY + 6);
  
        // Draw vertical and horizontal lines for the right column
        pdf.line(pageWidth / 1.5, currentY - 8, pageWidth / 1.5, currentY + 58);
        pdf.line(pageWidth / 1.5, currentY + 58, pageWidth - 10, currentY + 58);
        pdf.setLineWidth(0.35)
        pdf.line(pageWidth / 1.236, currentY - 8, pageWidth / 1.236, currentY + 36);
        // Totals Section (Right side)
        pdf.setFontSize(9);
        let rightY = currentY;
  
        // 1. Sub Total
        pdf.setFont('Verdana', 'normal');
        pdf.text('Sub Total:', rightColumnX + 30, rightY);
        pdf.setFont('NotoSans', 'normal');
        const subTotalText = formatCurrency(invoice.subTotal);
        pdf.text(subTotalText, rightColumnX + rightColumnWidth - pdf.getTextWidth(subTotalText), rightY);
  
        // 2. CGST
        rightY += 6;
        pdf.setFont('Verdana', 'normal');
        pdf.text(`CGST (${invoice.cgstRate || 0}%):`, rightColumnX + 30, rightY);
        pdf.setFont('NotoSans', 'normal');
        const cgstText = formatCurrency(invoice.cgst || 0);
        pdf.text(cgstText, rightColumnX + rightColumnWidth - pdf.getTextWidth(cgstText), rightY);
  
        // 3. SGST
        rightY += 6;
        pdf.setFont('Verdana', 'normal');
        pdf.text(`SGST (${invoice.sgstRate || 0}%):`, rightColumnX + 30, rightY);
        pdf.setFont('NotoSans', 'normal');
        const sgstText = formatCurrency(invoice.sgst || 0);
        pdf.text(sgstText, rightColumnX + rightColumnWidth - pdf.getTextWidth(sgstText), rightY);
        if (invoice.totalDiscount > 0) {
          rightY += 6;
          pdf.setFont('Verdana', 'normal');
          pdf.text(`Discount :`, rightColumnX + 30, rightY);
          pdf.setFont('NotoSans', 'normal');
          const totalDiscount = formatCurrency(invoice.totalDiscount || 0);
          pdf.text(`- ${totalDiscount}`, rightColumnX + rightColumnWidth - pdf.getTextWidth(sgstText), rightY);
        }
        // 4. Total (Bold value)
        rightY += 6;
        pdf.setFont('Verdana', 'bold');
        pdf.text('Total:', rightColumnX + 30, rightY);
        pdf.setFont('NotoSans', 'normal');
  
        // Simulate bold for rupee value
        const totalText = formatCurrency(invoice.total);
        for (let i = 0; i < 2; i++) {
          pdf.text(totalText, rightColumnX + rightColumnWidth - pdf.getTextWidth(totalText) + i * 0.2, rightY);
        }
  
        // 5. Balance Due (Bold value)
        rightY += 6;
        pdf.setFont('Verdana', 'bold');
        pdf.text('Balance Due:', rightColumnX + 30, rightY);
        pdf.setFont('NotoSans', 'normal');
        const balanceText = formatCurrency(invoice.balanceDue || invoice.total);
        for (let i = 0; i < 2; i++) {
          pdf.text(balanceText, rightColumnX + rightColumnWidth - pdf.getTextWidth(balanceText) + i * 0.2, rightY);
        }
  
        currentY += 20;
  
        // Thank you message
        pdf.setFontSize(9);
        pdf.setFont('Verdana', 'normal');
        pdf.text('Thank you for the valuable business! We will always be at', 15, currentY);
        pdf.text('your desk to support you.', 15, currentY + 5);
  
        // Authorized signature section with seal and signature images
        const signatureY = currentY + 15;
        //  pdf.line(pageWidth/1.5, pageHeight-100, pageWidth/1.5, pageHeight-70);
        pdf.line(pageWidth / 1.5, signatureY, pageWidth - 10, signatureY);
        // Add signature image if available
        try {
          const signatureImg = './image/sign.jpeg';
          pdf.addImage(signatureImg, 'JPEG', rightColumnX + 55, signatureY + 5, 20, 15);
        } catch (error) {
          console.log('Signature image not found');
        }
  
        // Add company seal if available
        try {
          const sealImg = './image/seal.jpeg';
          pdf.addImage(sealImg, 'JPEG', rightColumnX + 30, signatureY + 1, 20, 20);
        } catch (error) {
          console.log('Seal image not found');
        }
  
        // Scanner image (QR code) if available
        try {
          const scannerImg = './image/scanner.png';
          pdf.addImage(scannerImg, 'PNG', rightColumnX + 40, signatureY + 25, 25, 25);
        } catch (error) {
          console.log('Scanner image not found');
        }
        pdf.setFontSize(7);
        pdf.setFont('Verdana', 'normal');
        pdf.text('Authorized Signature', rightColumnX + 50, signatureY + 20);
  
        currentY = signatureY - 5;
  
  
        currentY += 6;
  
        pdf.setFontSize(8);
        pdf.setFont('Verdana', 'bold');
        pdf.text('Terms & Conditions:', 15, currentY);
  
        pdf.setFont('Verdana', 'normal');
        currentY += 5;
  
        // Use dynamic terms and conditions from invoice data
        const termsAndConditions = invoice.termsAndConditions || 'Full payment is due upon receipt of this invoice. Late payment may incur additional charges as per the applicable rates.';
        const termsLines = wrapText(termsAndConditions, pageWidth - 140);
        termsLines.forEach((line, index) => {
          pdf.text(line, 15, currentY + (index * 4));
        });
        currentY += Math.max(termsLines.length * 4, 8); // Minimum spacing
  
        currentY += 5;
        // DYNAMIC Bank Details
        pdf.setFontSize(8);
        pdf.setFont('Verdana', 'bold');
        pdf.text('Our Bank Details:', 15, currentY);
        currentY += 5;
  
        pdf.setFont('Verdana', 'normal');
        // Use dynamic bank details from invoice data
        const bankDetails = invoice.bankDetails || `Name: Excerpt Technologies Private Limited
  Account Number: 10063739760
  Name of Bank: IDFC First Bank  
  IFSC Code: IDFB0080151
  PAN No: AAGCE2327K`;
  
        const bankDetailsLines = bankDetails.split('\n');
        bankDetailsLines.forEach((line, index) => {
          if (index === 0 || index === 1) {
            pdf.setFont('Verdana', 'bold'); // Bold for first line
          } else {
            pdf.setFont('Verdana', 'normal'); // Normal for others
          }
          pdf.text(line, 15, currentY + (index * 4));
        });
  
  
        currentY += bankDetailsLines.length - 8;
        // Footer
        // const footerY = pageHeight - 25;
        // pdf.setDrawColor(0, 0, 0);
        // pdf.line(15, footerY, pageWidth - 15, footerY);
  
        pdf.setFontSize(8);
        pdf.setTextColor(0, 0, 255);
        pdf.text('https://excerptech.com', 15, pageHeight - 10);
        pdf.setTextColor(0, 0, 0);
        pdf.text('E-mail: info@excerptech.com', pageWidth - 65, pageHeight - 10);
  
        // Instead of saving, open preview in new tab
        // const pdfOutput = pdf.output('bloburl');
        // window.open(pdfOutput, '_blank');
        const invoiceNumberParts = invoice.invoiceNumber.split('/');
        const lastNumber1 = invoiceNumberParts[invoiceNumberParts.length - 1];
  
        // Get company name, default to 'Company' if not available
        const companyName1 = invoice.billtocompanyname || invoice.billToCompanyName || 'Company';
  
        // Create filename: INV [lastNumber] [companyName]
        const filename = `INV ${lastNumber1} ${companyName1}.pdf`;
  
        const pdfOutput = pdf.output('bloburl');
        const newWindow = window.open(pdfOutput, '_blank');
        // Set the title of the new window to match the filename
        if (newWindow) {
          newWindow.document.title = filename;
        }
  
      } catch (error) {
        console.error('Error generating PDF preview:', error);
        alert('Error generating PDF preview. Please try again.');
      } finally {
       setPreviewing(null);
      }
    };

const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setSaving(true); // Add loading state for the button

      // First, save the invoice
      const response = await axios.post('/invoices', {
        ...invoiceData,
        parts,
        discounts,
        cgstRate,
        sgstRate,
      });

      const savedInvoice = response.data;

      // Update the last invoice number
      setLastInvoiceNumber(prev => prev + 1);

      // Now generate PDF preview with the saved invoice data (including _id)
      await previewInvoicePDF(savedInvoice);

      // Navigate to invoice display page
      navigate(`/invoice-display`);

    } catch (error) {
      console.error('Error saving invoice:', error);
      alert('Error saving invoice. Please try again.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <form className="invoice-form" onSubmit={handleSubmit}>
      <div className="header">
        <img src="/Image/excerpt.png" alt="Excerpt Logo" style={{ height: '100px', width: '170px' }} />
        <h2>INVOICE</h2>
      </div>

      <div className="company-info">
        <h3>Excerpt Technologies Pvt Ltd</h3>
        <p>B133/1, 2nd Fl, KSSDC ITI Estate, Whitefield Rd,</p>
        <p>Mahadevpura Post, Bangalore - 560048</p>
        <p>Phone: +91(636) 465 7660, +91 (990) 050 2404</p>
        <p>GSTIN: 29AAGCE2327K1ZH</p>
        <p>LUT No.: AD291021005439D</p>
      </div>

      <div>
        <div className='row'>
          <div className='col-xl-2'>
            <label>
              Invoice: </label>
            <input type="text" name="invoiceNumber" className='form-control form-control-sm' value={invoiceData.invoiceNumber} readOnly />

          </div>
          <div className='col-xl-2'>
            <label>
              Year:</label>
            <select name="year" value={invoiceData.year} className='form-control form-control-sm' onChange={handleInvoiceDataChange}>

              <option value="25-26">2025-2026</option>
              <option value="26-27">2026-2027</option>
            </select>
          </div>
          <div className='col-xl-2'>
            <label>
              Date:</label>
            <input
              type="date"
              name="date"
              className='form-control form-control-sm'
              value={invoiceData.date}
              onChange={handleInvoiceDataChange}
              onKeyDown={(e) => {
                // Allow tab, enter, and escape keys
                if (!['Tab', 'Enter', 'Escape'].includes(e.key)) {
                  e.preventDefault();
                }
              }}
              onFocus={(e) => e.target.showPicker && e.target.showPicker()}
              style={dateInputStyle}
            />
          </div>
          <div className='col-xl-2'>
            <label>
              Terms:</label>
            <input type="text" className='form-control form-control-sm' name="terms" value={invoiceData.terms} onChange={handleInvoiceDataChange} />
          </div>
          <div className='col-xl-2'>
            <label>
              Due Date:</label>
            <input type="date" className='form-control form-control-sm' name="dueDate" value={invoiceData.dueDate} onChange={handleInvoiceDataChange}
              onKeyDown={(e) => {
                // Allow tab, enter, and escape keys
                if (!['Tab', 'Enter', 'Escape'].includes(e.key)) {
                  e.preventDefault();
                }
              }}
              onFocus={(e) => e.target.showPicker && e.target.showPicker()}
              style={dateInputStyle} />
          </div>
        </div>
        <div>

          <div className="row">
            <div className="col-xl-6">
              <h4>Bill To:</h4>
              <input
                type="text"
                name="billToName"
                placeholder="Name"
                value={invoiceData.billToName}
                onChange={handleInvoiceDataChange}
              />
              <input
                type="text"
                name="billtocompanyname"
                placeholder="Company Name"
                value={invoiceData.billtocompanyname}
                onChange={handleInvoiceDataChange}
              />
              <input
                type="text"
                name="billToAddress"
                placeholder="Address"
                value={invoiceData.billToAddress}
                onChange={handleInvoiceDataChange}
              />
              <input
                type="tel"
                name="billTophone"
                placeholder="+91XXXXXXXXXX"
                value={invoiceData.billTophone}
                onChange={handleInvoiceDataChange}
                style={{
                  borderColor: invoiceData.billTophone && !validatePhone(invoiceData.billTophone) ? 'red' : ''
                }}
              />
              <input
                type="email"
                name="billToemail"
                placeholder="email@example.com"
                value={invoiceData.billToemail}
                onChange={handleInvoiceDataChange}
                style={{
                  borderColor: invoiceData.billToemail && !validateEmail(invoiceData.billToemail) ? 'red' : ''
                }}
              />
              <input
                type="text"
                name="billTogstin"
                placeholder="15 digit GST number"
                value={invoiceData.billTogstin}
                onChange={handleInvoiceDataChange}
                style={{
                  borderColor: invoiceData.billTogstin && !validateGST(invoiceData.billTogstin) ? 'red' : ''
                }}
              />
            </div>

            {/* Add checkbox here */}


            <div className="ship-to col-xl-6">
              
              <div style={{ display: 'flex', alignItems: 'center' }}>
                        <label style={{ display: 'flex', alignItems: 'center', gap: '8px', whiteSpace: 'nowrap' }}>
                          <input type="checkbox" checked={sameAsBillTo} onChange={handleSameAsBillTo} />
                          Ship To same as Bill To
                        </label>
                      </div>
              <h4>Ship To:</h4>
              <input
                type="text"
                name="shipToName"
                placeholder="Name"
                value={invoiceData.shipToName}
                onChange={handleInvoiceDataChange}
              // disabled={sameAsBillTo}
              />
              <input
                type="text"
                name="shipTocompanyname"
                placeholder="Company Name"
                value={invoiceData.shipTocompanyname}
                onChange={handleInvoiceDataChange}
              // disabled={sameAsBillTo}
              />
              <input
                type="text"
                name="shipToAddress"
                placeholder="Address"
                value={invoiceData.shipToAddress}
                onChange={handleInvoiceDataChange}
              // disabled={sameAsBillTo}
              />
              <input
                type="tel"
                name="shipTophone"
                placeholder="+91XXXXXXXXXX"
                value={invoiceData.shipTophone}
                onChange={handleInvoiceDataChange}
                // disabled={sameAsBillTo}
                style={{
                  borderColor: invoiceData.shipTophone && !validatePhone(invoiceData.shipTophone) ? 'red' : ''
                }}
              />
              <input
                type="email"
                name="shipToemail"
                placeholder="email@example.com"
                value={invoiceData.shipToemail}
                onChange={handleInvoiceDataChange}
                // disabled={sameAsBillTo}
                style={{
                  borderColor: invoiceData.shipToemail && !validateEmail(invoiceData.shipToemail) ? 'red' : ''
                }}
              />
              <input
                type="text"
                name="shipTogstin"
                placeholder="15 digit GST number"
                value={invoiceData.shipTogstin}
                onChange={handleInvoiceDataChange}
                // disabled={sameAsBillTo}
                style={{
                  borderColor: invoiceData.shipTogstin && !validateGST(invoiceData.shipTogstin) ? 'red' : ''
                }}
              />
            </div>
          </div>


        </div>
      </div>

      <table>
        <thead>
          <tr>
            <th>Item & Description</th>
            <th>Amount</th>
          </tr>
        </thead>
        <tbody>
          {parts.map((part, partIndex) => (
            <React.Fragment key={partIndex}>
              <tr>
                <td colSpan="2" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <label style={{ fontWeight: 'bold', minWidth: '100px' }}>Part Title:</label>
                  <input
                    type="text"
                    value={part.title}
                    onChange={(e) => handlePartTitleChange(partIndex, e.target.value)}
                    style={{ flexGrow: 1, fontWeight: 'bold', fontSize: '1.1em' }}
                  />
                  <button
                    type="button"
                    onClick={() => handleDeletePart(partIndex)}
                    style={{
                      backgroundColor: 'red',
                      color: 'white',
                      border: 'none',
                      cursor: 'pointer',
                      padding: '5px 10px',
                    }}
                  >
                    Delete
                  </button>
                </td>
              </tr>
              {part.items.map((item, itemIndex) => (
                <tr key={itemIndex}>
                  <td>
                    <input
                      type="text"
                      placeholder="Description"
                      value={item.description}
                      onChange={(e) => handlePartItemChange(partIndex, itemIndex, 'description', e.target.value)}
                      required
                    />
                  </td>
                  <td style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <input
                      type="text"
                      placeholder="Amount"
                      value={item.amount}
                      onChange={(e) => handlePartItemChange(partIndex, itemIndex, 'amount', e.target.value)}
                      min="0"
                      step="0.01"
                      required
                    />
                    <button
                      type="button"
                      onClick={() => handleDeletePartItem(partIndex, itemIndex)}
                      style={{
                        backgroundColor: 'red',
                        color: 'white',
                        border: 'none',
                        cursor: 'pointer',
                        padding: '5px 10px',
                      }}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
              <tr>
                <td colSpan="2">
                  <button type="button" onClick={() => handleAddPartItem(partIndex)}>
                    + Add Item to {part.title}
                  </button>
                </td>
              </tr>
            </React.Fragment>
          ))}
        </tbody>
      </table>

      <div style={{ marginBottom: '15px' }}>
        <button type="button" onClick={handleAddNewPart}>
          + Add New Part
        </button>
      </div>
      {/* Add this section after your parts table and before invoice summary */}
      <div className="discount-section" style={{ marginTop: '20px', marginBottom: '20px' }}>
        <h4>Discounts:</h4>
        <table>
          <thead>
            <tr>
              <th>Discount Label</th>
              <th>Amount</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {discounts.map((discount, index) => (
              <tr key={index}>
                <td>
                  <input
                    type="text"
                    placeholder="Discount description"
                    value={discount.label}
                    onChange={(e) => handleDiscountChange(index, 'label', e.target.value)}
                  />
                </td>
                <td>
                  <input
                    type="text"
                    placeholder="Discount amount"
                    value={discount.amount}
                    onChange={(e) => handleDiscountChange(index, 'amount', e.target.value)}
                  />
                </td>
                <td>
                  <button
                    type="button"
                    onClick={() => handleDeleteDiscount(index)}
                    style={{
                      backgroundColor: 'red',
                      color: 'white',
                      border: 'none',
                      cursor: 'pointer',
                      padding: '5px 10px',
                    }}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <button type="button" onClick={handleAddDiscount} style={{ marginTop: '10px' }}>
          + Add Discount
        </button>
      </div>
      <div className="invoice-summary">
        <label>
          Sub Total:
          <input type="number" value={invoiceData.subTotal} readOnly />
        </label>

        <label>
          CGST (%):
          <input
            type="text"
            value={cgstRate}
            onChange={handleCgstRateChange}
            placeholder="Enter CGST %"
            onInput={(e) => {
              const val = e.target.value;
              if (/^\d{0,2}(\.\d{0,2})?$/.test(val) || val === "") {
                e.target.value = val;
              } else {
                e.target.value = cgstRate;
              }
            }}
            inputMode="decimal"
          />
        </label>

        <label>
          SGST (%):
          <input
            type="text"
            value={sgstRate}
            onChange={handleSgstRateChange}
            placeholder="Enter SGST %"
            onInput={(e) => {
              const val = e.target.value;
              if (/^\d{0,2}(\.\d{0,2})?$/.test(val) || val === "") {
                e.target.value = val;
              } else {
                e.target.value = cgstRate;
              }
            }}
            inputMode="decimal"
          />
        </label>


        <label>
          CGST Amount:
          <input type="number" value={invoiceData.cgst} readOnly />
        </label>

        <label>
          SGST Amount:
          <input type="number" value={invoiceData.sgst} readOnly />
        </label>

        <label style={{ fontWeight: 'bold' }} >
          Total:
          <input type="number" value={invoiceData.total} readOnly />
        </label>
        <label>
          Balance Due:
          <input
            type="text"
            name="balanceDue"
            value={invoiceData.balanceDue}
            onChange={handleInvoiceDataChange}
            onInput={(e) => {
              const val = e.target.value;
              if (/^\d*\.?\d{0,2}$/.test(val) || val === "") {
                e.target.value = val;
              } else {
                e.target.value = invoiceData.balanceDue;
              }
            }}
            inputMode="decimal"
            placeholder="Enter amount"
          />
        </label>


        <label>
          Total In Words:
          <input
            type="text"
            name="totalInWords"
            value={invoiceData.totalInWords}
            onChange={handleInvoiceDataChange}
          />
        </label>
      </div>
      <div className="additional-fields">
        <label>
          Thank You Message:
          <textarea
            name="thankYouMessage"
            value={invoiceData.thankYouMessage}
            onChange={handleInvoiceDataChange}
            rows={3}
            style={{ width: '100%', resize: 'vertical' }}
          />
        </label>

        <label>
          Terms & Conditions:
          <textarea
            name="termsAndConditions"
            value={invoiceData.termsAndConditions}
            onChange={handleInvoiceDataChange}
            rows={4}
            style={{ width: '100%', resize: 'vertical' }}
          />
        </label>

        <label>
          Bank Details:
          <textarea
            name="bankDetails"
            value={invoiceData.bankDetails}
            onChange={handleInvoiceDataChange}
            rows={6}
            style={{ width: '100%', resize: 'vertical' }}
          />
        </label>
      </div>
      <button
        type="submit"
        disabled={saving}
        className="btn btn-primary"
        style={{ width: "180px" }}
      >
        {saving ? 'Saving & Generating...' : 'Save & Preview PDF'}
      </button>
    </form>
  );
};

export default InvoiceForm;
